import { Routes, RouterModule } from '@angular/router';

import { ChildrenListComponent } from './1-children-list/ChildrenListComponent';
import { ActivitesListComponent } from './3-activites-list/ActivitesListComponent';
import { ExcursionsComponent } from './4-excursions/ExcursionsComponent';
import { BusOptionComponent} from './5-bus-option/BusOptionComponent';
import { PaymentComponent } from './6-payment/PaymentComponent';
import { FinishComponent } from './6-finish/FinishComponent';
import { ViewBookingComponent } from './view-booking/ViewBookingComponent';
import { AttendanceComponent } from './attendance/AttendanceComponent';
import { QuestionAnswerComponent } from './2-Q&A/QuestionAnswerComponent';

const BookingRoutes: Routes = [
    {
        path: 'booking',
        children: [
            {
                path: 'students', 
                component: ChildrenListComponent
            },
            {
                 path: 'activites-list', 
                 component: ActivitesListComponent
            },
            {
                path: 'question-answer', 
                component: QuestionAnswerComponent
            },
            {
                path: 'excursions', 
                component: ExcursionsComponent
            },
            {
                path: 'bus', 
                component: BusOptionComponent
            },          
            {
                 path: 'payment', 
                 component: PaymentComponent
            },
            {
                 path: 'finish', 
                 component: FinishComponent
            }
        ],
    },
    {
        path: 'booking/:id',
        component: ViewBookingComponent    
    },
    {
        path: 'view-attendance',
        component: AttendanceComponent    
    },
];

export const bookingRouting = RouterModule.forChild(BookingRoutes);


// WEBPACK FOOTER //
// ./src/holiday/parent/booking/BookingRouting.ts